module.exports = __webpack_public_path__ + "static/media/vegitables_47.11a850e2.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_47.csv
// module id = 632
// module chunks = 0